export default function IconHanger() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 64.413 60"
    >
      <path
        d="m60.622 45.281-15.94-11.89a13.33 13.33 0 0 0-4.492-6.17 13.072 13.072 0 0 0-6.096-2.55v-4.854l3.769-2.827a9.362 9.362 0 0 0 3.78-7.554C41.643 4.233 37.41 0 32.206 0S22.77 4.233 22.77 9.436h3.774c0-3.122 2.54-5.662 5.662-5.662s5.662 2.54 5.662 5.662a5.62 5.62 0 0 1-2.27 4.534l-5.279 3.96v6.74a13.069 13.069 0 0 0-6.096 2.55 13.33 13.33 0 0 0-4.491 6.171l-15.94 11.89c-4.172 3.11-5.034 9.035-1.923 13.206L2.997 60l3.689-2.751h51.041L61.416 60l1.128-1.513c3.111-4.17 2.249-10.095-1.922-13.206ZM3.83 52.03a5.623 5.623 0 0 1 2.218-3.723L22.975 35.68l.178-.604c.992-3.369 3.807-5.878 7.166-6.573v6.409L4.023 54.526a5.64 5.64 0 0 1-.193-2.496Zm7.916 1.444 20.46-15.26 20.46 15.26h-40.92Zm48.644 1.052L34.094 34.912v-6.408c3.36.694 6.174 3.204 7.166 6.573l.178.604 16.927 12.626c1.212.904 2 2.226 2.218 3.723.124.85.055 1.699-.193 2.496Z"
        data-name="Layer 1"
        style={{
          fill: "var(--color-primary(-alpha(-light)))",
          strokeWidth: 0,
        }}
      />
    </svg>
  );
}
